import React from 'react';
import generateComponentKeyString from './generateComponentKeyString';

export default (IrisWrapperComponent, irisContentMeta, index, irisComponents, propsData) => {
    const componentContent = irisContentMeta.content || {};
    const ComponentToRender = IrisWrapperComponent.component;
    const rndKeyString = generateComponentKeyString(irisContentMeta.componentType, index);

    const { mapToProps } = IrisWrapperComponent;
    const automationId = irisContentMeta.componentType;
    let mappedProps = {};
    const baseProps = {
        rndKeyString,
        ...propsData,
        automationId,
        irisComponentsWithoutGrid: irisComponents,
        componentType: irisContentMeta.componentType,
    };
    /* istanbul ignore else */
    if (mapToProps) {
        mappedProps = mapToProps(
            componentContent,
            baseProps.pageType,
            baseProps.deviceType,
            baseProps.preferences,
            baseProps.automationId,
            baseProps.featureFlags,
            baseProps.irisComponentsWithoutGrid,
            baseProps.componentType
        );
    } else {
        mappedProps = {
            ...irisContentMeta.content,
            ...baseProps,
        };
    }
    // TODO: action handling is pending
    return <ComponentToRender key={rndKeyString} {...mappedProps} />;
};
